import styled from 'styled-components';
import { Form } from 'antd';

export const UiFormItem = styled(Form.Item)`
	margin-bottom: 0px;
`;

export const UiErrorMsg = styled.div`
	color: #f00;
`;